import React, { useState } from 'react';
import { Popover, Button } from 'antd';
import style from './cancel-popover.module.scss';
import { getIn18Text } from 'api';
export const CancelPopover = ({ children, onConfirm, disable = false, placement = 'bottom' }) => {
    const [visible, setVisible] = useState(false);
    const overlay = () => (React.createElement("div", { className: style.card },
        React.createElement("div", { className: style.title }, getIn18Text('GUIZEWEIBAOCUN')),
        React.createElement("div", { className: style.btnGroup },
            React.createElement(Button, { className: style.btnCancel, onClick: () => setVisible(false) }, getIn18Text('JIXUBIANJI')),
            React.createElement(Button, { className: style.btnConfirm, type: "primary", danger: true, onClick: () => {
                    onConfirm();
                    setVisible(false);
                } }, getIn18Text('TUICHU')))));
    return disable ? (React.createElement(React.Fragment, null, children)) : (React.createElement(Popover, { overlayClassName: style.cancelTooltip, onVisibleChange: v => setVisible(v), content: overlay, visible: visible, trigger: "click", placement: placement, getPopupContainer: e => (e.parentElement ? e.parentElement : e) }, children));
};
